/*
 * @Author: LQ
 * @Date: 2022-05-26 09:05:13
 * @LastEditors: LQ
 * @LastEditTime: 2022-07-12 15:38:35
 * @FilePath: \scm-pc\src\utils\error-handler.js
 * @Description:
 *
 * Copyright (c) 2022 by LQ/量迅, All Rights Reserved.
 */
import { nextTick } from 'vue';

export default {
  errorHandler(err, vm, info) {
    nextTick(() => {
      console.error(err);
      console.log(
        `发生错误组件：${vm.$.vnode.type.__file} \n错误信息错误：${err} \n所在生命周期：${info}`,
        '\n当前组件实例信息：',
        vm
      );
    });
  },

  onerror(message, source, lineno, colno, error) {
    const data = [
      `window:message:${message}\n错误URL: ${source}\n错误行号: ${lineno}/${colno}`,
      '\n错误：',
      error,
    ];
    if (error) {
      console.error(...data);
    } else {
      console.log(...data);
    }
  },
};
